import React from "react";
import Typography from "@material-ui/core/Typography";
import { FastField, Field } from "formik";

export default ({
  name,
  j = 0,
  wrapper: Wrapper = Typography,
  fast = true,
  FieldComponent = fast ? FastField : Field,
  content,
  children,
  ...rest
}) => {
  if (content !== undefined) {
    return (Array.isArray(content) ? content : [content]).map(text =>
      typeof text !== "function" ? (
        <Wrapper key={j++} {...rest}>
          {text}
        </Wrapper>
      ) : (
        <FieldComponent name={name} key={j++}>
          {({ field, form }) => text && text(form, field)}
        </FieldComponent>
      )
    );
  }

  return (
    <FieldComponent name={name} key={j++}>
      {({ field }) => <Typography {...rest}>{field.value}</Typography>}
    </FieldComponent>
  );
};
